import { z } from "zod";

export type CustomizableColumn = {
  alwaysVisible: boolean;
  bit: number;
  label: string;
};

const CustomColumnTemplateSchema = z.object({
  settingId: z.string(),
  name: z.string(),
  defaultTemplate: z.boolean(),
  columns: z.number(),
});

export const CustomColumnTemplateListSchema = z.array(CustomColumnTemplateSchema);
export type CustomColumnTemplate = z.infer<typeof CustomColumnTemplateSchema>;
